/* eslint-disable key-spacing */
import { hsl } from '../../../utils/svgs'

export default {
    fill: {
        primaryDark:    hsl(30, 22, 45),
        primaryLight:   hsl(30, 30, 57),
        secondaryDark:  hsl(225, 20, 35),
        sclera:         hsl(225, 20, 90),
    },
}
